import { Button } from "reactstrap";

import AppDrawer from "./AppDrawer";
import CloudList from "../../views/cloud/CloudList";
import { DrawerProps } from "./DrawerTypes";
import { useNavigate } from "react-router-dom";

interface Props extends DrawerProps {}

const CloudSwitcherDrawer = ({ open, onClose }: Props) => {
  const navigate = useNavigate();

  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      size={"sm"}
      placement={"right"}
      backdrop={true}
      headerTitle="Switch Clouds"
      headerOptions={
        <>
          <Button outline size="sm" onClick={() => navigate("/clouds")}>
            View All
          </Button>
          <Button
            size="sm"
            color="primary"
            onClick={() => navigate("/create/cloud")}
          >
            New Cloud
          </Button>
        </>
      }
      body={
        <CloudList
          isDrawer={true}
          closeDrawer={onClose}
          favoritesEnabled={true}
        />
      }
    />
  );
};

export default CloudSwitcherDrawer;
